import moment from 'moment-timezone'

import { Picker } from './picker'

const getMoment = (timezone) => (timezone ? moment.tz(timezone) : moment())

const today = (timezone) => {
  const m = getMoment(timezone)
  return [m.format('YYYY-MM-DD'), m.format('YYYY-MM-DD')]
}

const dateRangeFor = (momentPeriod, timezone) => {
  const startM = getMoment(timezone)
  const endM = getMoment(timezone)
  return [startM.startOf(momentPeriod).format('YYYY-MM-DD'), endM.endOf(momentPeriod).format('YYYY-MM-DD')]
}

const getStartDate = (startDate, timezone) => {
  if (startDate) {
    return timezone ? moment.tz(startDate, timezone).format('YYYY-MM-DD') : moment(startDate).format('YYYY-MM-DD')
  }
  return getMoment(timezone).format('YYYY-MM-DD')
}

const getEndDate = (endDate, startDate, timezone) => {
  if (endDate) {
    return timezone ? moment.tz(endDate, timezone).format('YYYY-MM-DD') : moment(endDate).format('YYYY-MM-DD')
  }
  return getStartDate(startDate, timezone)
}

const getDates = (period, startDate, endDate, timezone) => {
  switch (period) {
    case 'today':
      return today(timezone)
    case 'this_week':
      return dateRangeFor('week', timezone)
    case 'this_month':
      return dateRangeFor('month', timezone)
    case 'this_year':
      return dateRangeFor('year', timezone)
    case 'all_time':
      return [null, null]
    default:
      return [getStartDate(startDate, timezone), getEndDate(endDate, startDate, timezone)]
  }
}

export const DateRangePicker = ({ period, startDate, endDate, timezone, onChange, isMIPage = false }) => {
  const [pickerStartDate, pickerEndDate] = getDates(period, startDate, endDate, timezone)

  return (
    <Picker
      startDate={pickerStartDate}
      endDate={pickerEndDate}
      timezone={timezone}
      onChange={onChange}
      period={period}
      isMIPage={isMIPage}
    />
  )
}
